import {useEffect, useRef} from 'react';
import hCaptchaClient from './hcaptcha-client';

export default function useHCaptcha({formRef, formId, siteKey, onStateChange}) {
    const containerRef = useRef(null);
    const controllerRef = useRef(null);
    const onStateChangeRef = useRef(onStateChange);

    onStateChangeRef.current = onStateChange;

    useEffect(() => {
        const formElement = formRef?.current || (formId ? document.getElementById(formId) : null);
        const containerElement = containerRef.current;

        if (!formElement || !containerElement) {
            return undefined;
        }

        const controller = hCaptchaClient.createHCaptchaController({
            formElement,
            containerElement,
            siteKey,
            onStateChange: (nextState) => onStateChangeRef.current?.(nextState),
        });

        controllerRef.current = controller;
        controller.init();

        return () => {
            controller.destroy();
            if (controllerRef.current === controller) {
                controllerRef.current = null;
            }
        };
    }, [formRef, formId, siteKey]);

    return {
        containerRef,
        controllerRef,
    };
}
